module.exports = __webpack_public_path__ + "media/images/tutors/PrepWorks-Salman-b94b9732f39d64c4ee4841169de0a6eb.jpg";